import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

export const ItemContainer = styled.li({
    lineHeight: getBaseTheme().texts.sizes.xs.lineHeight,
    '&:last-child': {
        borderBottom: 0
    }
});

export const ErrorText = styled.p({
    color: 'red', // TODO-TH
    margin: 0
});

export const ItemWrapper = styled.div({
    margin: `0 ${getBaseTheme().spaces.inline.s}`,
    padding: getBaseTheme().spaces.inset.xs,
    borderBottom: '1px solid #ebebeb',
    backgroundColor: getBaseTheme().colors.area.default.backgroundColor
});

export const ItemParagraph = styled.div(
    {
        width: '100%',
        margin: 0,
        '&:hover': {
            backgroundColor: getBaseTheme().colors.area.hover.backgroundColor
        }
    },
    ({ error }) => {
        if (error) {
            return {
                margin: 0,
                letterSpacing: '0.3px',
                lineHeight: '1.5rem',
                color: 'lightgrey'
            };
        }
        return undefined;
    }
);
